import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {CommonService} from 'src/app/core/services/common.service';
import {Message} from 'src/app/core/class/message';
import {ChangePasswordComponent} from '../../change-password/change-password.component';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from '../../../../core/services/authentication.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss']
})
export class PublicHeaderComponent extends BaseComponent implements OnInit {
  userName = localStorage.getItem('userName');
  isAdmin = false;
  isLogin = false;

  constructor(
    public router: Router,
    private auth: AuthenticationService,
    private translate: TranslateService,
    public commonService: CommonService,
    public message: Message,
    private dialog: MatDialog,
  ) {
    super(commonService, message);
  }

  ngOnInit() {
    const userType = localStorage.getItem('userType');
    if (Number(userType) === 0) {
      this.isAdmin = true;
    }
    this.isLogin = this.auth.isLoggedIn();
  }

  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['home']);
  }

  login() {
    this.router.navigate(['enterprise-login']);
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '50%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  gotoApplication() {
    const userType = localStorage.getItem('userType');
    if (!this.isAdmin) {
      this.router.navigate(['/home-enterprise']);
    }
  }
}
